import * as React from 'react';
import { memo } from 'react';

const PreferredLocations = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10.5601"
      cy="10.6736"
      r="9.34276"
      stroke="white"
      strokeWidth="1.00101"
    />
    <path
      d="M14.8976 10.6736C14.8976 13.332 14.3669 15.7141 13.5318 17.413C12.6809 19.1444 11.5997 20.0163 10.5599 20.0163C9.52007 20.0163 8.43892 19.1444 7.58794 17.413C6.75289 15.7141 6.22218 13.332 6.22218 10.6736C6.22218 8.01512 6.75289 5.63302 7.58794 3.93413C8.43892 2.20281 9.52007 1.33083 10.5599 1.33083C11.5997 1.33083 12.6809 2.20281 13.5318 3.93413C14.3669 5.63302 14.8976 8.01512 14.8976 10.6736Z"
      stroke="white"
      strokeWidth="1.00101"
    />
    <path d="M2.71875 5.83533H18.7349" stroke="white" strokeWidth="1.00101" />
    <path d="M2.71875 15.8455H18.0676" stroke="white" strokeWidth="1.00101" />
    <path
      d="M1.38379 10.5067L19.402 10.5067"
      stroke="white"
      strokeWidth="1.00101"
    />
  </svg>
);

const Memo = memo(PreferredLocations);
export default Memo;
